var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer g_restrict"},[_c('footer-socials'),(this.$breakpoint.isS)?_c('button-top'):_vm._e(),_c('footer-copyright')],1)}
var staticRenderFns = []

export { render, staticRenderFns }